/**
 * Tiny store so a recording upload can keep running after the user leaves the
 * meeting screen, and the app shell can show its progress.
 */
let state = null; // { meetingId, title, progress }
const subs = new Set();

export const getBackgroundUpload = () => state;

export const setBackgroundUpload = (next) => {
  state = next;
  subs.forEach((fn) => fn(state));
};

export const subscribeBackgroundUpload = (fn) => {
  subs.add(fn);
  return () => subs.delete(fn);
};
